import React from 'react'
import Link from 'gatsby-link'
import LogoSun from '../img/logo-sun.png'
import SayHey from '../img/say-hey.png'
import IconTwitter from '../img/icons/twitter.png'
import IconFacebook from '../img/icons/facebook.png'
import IconInstagram from '../img/icons/instagram.png'


class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0
        };

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({width: window.innerWidth, height: window.innerHeight});
    }

    render() {
        return (
            <footer className="footer">
                {
                    this.state.width >= 769 ?
                        <div className="section-content-wrapper columns bottom">
                            <div className="column">
                                <p>
                                    <img src={SayHey} style={{maxWidth: 100, marginBottom: 25}}/>
                                </p>
                                <p>
                                    Email: <a href="mailto:hello@jenniferemerling.com">hello@jenniferemerling.com</a><br/>
                                    Phone: <a href="tel:1-559-360-6591">+1 (559) 360-6591</a> <br/>
                                    Location: Fresno, California USA<br/>
                                </p>
                            </div>
                            <div className="column has-text-centered">
                                <p>
                                    <img src={LogoSun} style={{maxWidth: 95, marginBottom: 10}}/>
                                </p>
                                <p>Jennifer Emerling &copy; {(new Date()).getFullYear()}</p>
                            </div>
                            <div className="column has-text-right">
                                <p className="social-icons">
                                    <a href="https://instagram.com/jemerling" target="_blank"><img src={IconInstagram}
                                                                                                   style={{width: 18}}/></a>
                                    <a href="https://www.facebook.com/jemerlingphoto" target="_blank"><img src={IconFacebook}
                                                                                                           style={{height: 17}}/></a>
                                    <a href="https://twitter.com/jemerling" target="_blank"><img src={IconTwitter}
                                                                                                 style={{width: 20}}/></a>
                                </p>
                                <p>Branding & website design by<br/>
                                    Gretchen Watson Studio Design</p>
                            </div>
                        </div>
                        :
                        <div className="section-content-wrapper columns center-column has-text-centered">
                            <div className="column">
                                <p>
                                    <img src={SayHey} style={{maxWidth: 100, marginBottom: 25}}/>
                                </p>
                                <p>
                                    Email: <a href="mailto:hello@jenniferemerling.com">hello@jenniferemerling.com</a><br/>
                                    Phone: <a href="tel:1-559-360-6591">+1 (559) 360-6591</a> <br/>
                                    Currently: <span>Fresno, California</span>
                                </p>
                                <p className="social-icons" style={{marginTop: 20}}>
                                    <a href="https://instagram.com/jemerling" target="_blank">
                                        <img src={IconInstagram} style={{width: 18, marginBottom: 0}}/>
                                    </a>
                                    <a href="https://www.facebook.com/jemerlingphoto" target="_blank">
                                        <img src={IconFacebook} style={{height: 17, marginBottom: 0}}/>
                                    </a>
                                    <a href="https://twitter.com/jemerling" target="_blank">
                                        <img src={IconTwitter} style={{width: 20, marginBottom: 0}}/>
                                    </a>
                                </p>
                            </div>
                            <div className="column">
                                <p>
                                    <img src={LogoSun} style={{maxWidth: 95, marginBottom: 10}}/>
                                </p>
                                <p>Jennifer Emerling &copy; {(new Date()).getFullYear()}</p>
                            </div>
                            <div className="column">

                                <p>Branding & website design by<br/>
                                    Gretchen Watson Studio Design</p>
                            </div>
                        </div>
                }
            </footer>
        )
    }
}


export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js